'use strict';

exports.__esModule = true;

exports['default'] = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case actions.ADD_AJAX:
      return [].concat(state, [{ id: action.id, state: action.state, progress: action.progress, tags: action.tags, xhr: action.xhr }]);

    case actions.REMOVE_AJAX:
      return state.filter(function (item) {
        return item.id !== action.id;
      });

    case actions.REMOVE_AJAX_RANGE:
      return state.filter(function (item) {
        return action.idList.indexOf(item.id) === -1;
      });

    case actions.UPDATE_AJAX_PROGRESS:
      return state.map(function (item) {
        return item.id === action.id ? { id: item.id, state: action.state, progress: action.progress, tags: item.tags, xhr: item.xhr } : item;
      });

    default:
      return state;
  }
};

var _actionTypes = require('./action-types');

var actions = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/ajax/reducer.js
 ** module id = 117
 ** module chunks = 0
 **/